import { Divider } from 'antd';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { QuestionTipContainer } from '../../../../../styles/QuestionTipContainer.styles';
import {
    blue01,
    blueDark01,
    grayDark01,
    grayDark03,
    grayDark05,
    grayLight01,
    grayLight03,
    grayLight04,
    blueLink,
    green,
    white,
    black,
    blue04,
} from '../../../../../styles/colors';
import { ErrorMessage, InvisibleButton, Text } from '../../../../../styles/common.styles';

const GeneralSection = styled('div')`
    padding: 20px 20px;
    position: relative;
    border-bottom: 1px solid ${grayLight01};
    &:after {
        content: '';
        position: absolute;
        top: 20px;
        right: 0;
        bottom: 20px;
        display: inline-block;
        width: 1px;
        background-color: ${grayLight03};
    }
    &.without-after {
        &:after {
            content: none;
        }
    }
`;

export const ProductContainer = styled('div')`
    margin-left: 40px;
    display: flex;

    &.shifted {
        @media screen and (max-width: 1800px) {
            width: 55%;
        }
    }
`;
export const TagsList = styled('div')`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
    align-content: flex-start;
    margin: 12px 20px;
    min-height: 32px;
    max-width: 550px;
    > * {
        flex: 0 0 auto;
    }
`;

// Not a palette tag: link-coloured text, border and tint, and it navigates to the Live Guideline.
export const LiveGuidelineTag = styled(Link)`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    height: 24px;
    padding: 4px 8px;
    border-radius: 4px;
    border: 1px solid ${blueLink};
    background-color: ${blueLink}1a;
    color: ${blueLink};
    font-family: 'Proxima Nova';
    font-size: 11px;
    line-height: 13px;
    white-space: nowrap;
    &:hover {
        color: ${blueLink};
        text-decoration: underline;
    }
`;

export const LiveGuidelineTagIcon = styled('img')`
    width: 12px;
    height: 12px;
`;

export const BrandSection = styled('div')`
    background-color: #e3eaf7;
    padding: 20px;
    flex: 1;
    width: 20%;
    min-width: 20%;
    .invisible {
        opacity: 0;
    }
    &.freeListing {
        background-color: #dceaed;
    }
    &.withBorder {
        border-bottom: 1px solid ${grayLight01};
    }
    @media screen and (max-width: 1500px) {
        flex: unset;
        width: 150px;
        min-width: unset;
    }
`;

export const BrandSectionInnerData = styled('div')`
    overflow-wrap: break-word;
`;

export const HelpButton = styled(InvisibleButton)`
    align-items: flex-start;
    margin-top: 2px;
    &.details {
        margin-top: 16px;
    }

    div {
        text-wrap: wrap;
        text-align: left;
        word-break: break-word;
        -ms-word-break: break-all;
        overflow-wrap: break-word;
        white-space: pre-wrap;
        -webkit-hyphens: auto;
        -moz-hyphens: auto;
        hyphens: auto;
    }
`;

export const ProductNameSection = styled(GeneralSection)`
    flex: 1;
    width: 0;
    overflow-wrap: break-word;
    .ant-input {
        width: 125px;
        font-size: 12px;
        line-height: 14px;
    }
    @media screen and (max-width: 1500px) {
        flex: unset;
        width: unset;
    }
`;

export const ProductItemPropertiesSection = styled(GeneralSection)`
    padding-right: 1px !important;
    .ant-input {
        width: 103px;
        font-size: 12px;
        line-height: 14px;
    }
    .ant-select-selector {
        width: 103px !important;
        padding: 5px 7px !important;
        height: 28px !important;
        .ant-select-selection-item {
            font-weight: 400 !important;
            font-size: 12px !important;
            line-height: 14px !important;
            color: ${blueDark01} !important;
        }
    }
    &.withoutBorder {
        border-bottom: none;
    }
`;

export const ProductPropertiesColumnsContainer = styled('div')`
    margin-left: 0px;
    display: flex;
`;

export const ProductItemPropertiesLeftSection = styled(GeneralSection)`
    padding-top: 6px !important;
    border-bottom-color: ${grayLight04};
    padding-left: 0px;
    margin-left: 20px;
    .ant-select {
        display: block !important;
    }
    .ant-input {
        width: 103px;
        height: 28px !important;
        font-size: 12px;
        line-height: 14px;
    }
    .ant-select-selector {
        width: 103px !important;
        padding: 5px 7px !important;
        height: 28px !important;
        .ant-select-selection-item {
            font-weight: 400 !important;
            font-size: 12px !important;
            line-height: 14px !important;
            color: ${blueDark01} !important;
        }
        .ant-select-selection-search {
            height: 28px !important;
            display: block !important;
            .ant-select-selection-search-input {
                height: 28px !important;
            }
        }
    }
`;

export const ProductItemLabel = styled(Text)`
    margin-bottom: 4px;
    margin-top: 12px;
`;

export const ProductItemLabelNoTopMargin = styled(Text)`
    margin-bottom: 4px;
    margin-top: 0px;
`;

export const ProductItemLabelMFR = styled(Text)`
    margin-bottom: 4px;
`;

export const PricingInputContainer = styled('div')`
    position: relative;
`;

export const FinishScheduleIdInputContainer = styled('div')`
    position: relative;
`;

export const PricingError = styled(ErrorMessage)`
    left: 0;
    bottom: -15px;
`;

export const FinishScheduleIdError = styled(ErrorMessage)`
    left: 0;
    bottom: -15px;
`;

export const DescriptionInputContainer = styled('div')`
    position: relative;

    input.ant-input {
        width: 100% !important;
        height: 28px !important;
    }
`;

export const DescriptionInputContainerMFR = styled('div')`
    position: relative;
    min-width: 187px;
`;

export const ProductItemPropertiesRightSection = styled(GeneralSection)`
    padding-top: 6px !important;
    border-bottom-color: ${grayLight04};
    .ant-input {
        width: 125px;
        height: 28px !important;
        font-size: 12px;
        line-height: 14px;
    }
    .ant-select-selector {
        width: 103px !important;
        padding: 5px 7px !important;
        .ant-select-selection-item {
            font-weight: 400 !important;
            font-size: 12px !important;
            line-height: 14px !important;
            color: ${blueDark01} !important;
        }
    }
    &.withoutBorder {
        border-bottom: none;
    }
`;

export const ProductRadioButtonContainer = styled('div')`
    margin-top: 8px;
    display: flex;
    align-items: center;
    gap: 16px;
    .ant-radio-inner::after {
        background-color: ${white};
    }
    .ant-radio-checked .ant-radio-inner {
        background-color: ${blue01};
    }
    .ant-radio-wrapper {
        color: ${grayDark01};
        font-weight: 400;
        font-size: 12px;
        line-height: 14px;
        margin-right: 4px;
    }
`;

export const ProductDatesContainer = styled('div')`
    margin-top: 0px;
    display: flex;
    align-items: left;
    gap: 16px;
`;

export const DateSection = styled(GeneralSection)`
    padding-top: 6px !important;
    min-width: 115px;
    border-bottom-color: ${grayLight04};
`;

export const ActionsSection = styled('div')`
    display: flex;
    min-width: 180px;
    padding: 0 10px 0 20px;
    border-bottom: 1px solid ${grayLight04};
    gap: 30px;
`;

export const ActionContainer = styled('div')`
    margin: 20px 0;
`;

export const ActionCloseContainer = styled('div')`
    margin-top: 10px;
    cursor: pointer;
`;
export const ProductItemDivider = styled(Divider)`
    border-top: 1px solid ${grayLight04};
    margin: 12px 0;
`;

export const ActionItem = styled('div')`
    align-items: center;
    display: flex;
    gap: 8px;
    margin-bottom: 12px;
    div {
        white-space: nowrap;
    }
    .ant-checkbox-inner {
        border-radius: 50%;
    }
    .ant-checkbox-checked {
        .ant-checkbox-inner {
            border-radius: 50%;
            background-color: ${green};
        }
    }

    .disabled-img {
        opacity: 0.3;
    }
`;

export const DetailItemsSection = styled('div')`
    display: flex;
    min-width: 950px;

    &.shifted {
        min-width: 875px;
        width: 50%;
    }
`;

export const ProductDetailsWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    width: 75%;
`;

export const EC3Url = styled('div')`
    display: flex;
    gap: 2px;
    a {
        font-weight: 400;
        font-size: 10px;
        line-height: 12px;
        color: #134fbd;
        &:hover {
            opacity: 0.5;
        }
    }
`;

export { QuestionTipContainer };

export const FavoriteButton = styled(InvisibleButton)`
    align-items: flex-start;
    margin-top: 0px;
    padding-bottom: 0px;
    &.favoriteButtonText {
        padding-top: 8px;
    }
`;

export const OneLineContainer = styled('div')`
    margin-top: 2px;
    margin-bottom: 8px;
    display: flex;
`;

export const DiscussAndUploadAndCounts = styled('div')`
    margin: 0 0 4px 0;
    display: flex;
    gap: 10px;
`;

export const TextCounts = styled(Text)`
    color: ${blueLink};
    font-weight: normal;
    font-size: 10px;
    line-height: 12px;
    font-family: 'Proxima Nova';
`;

export const TextCountsItem = styled('span')`
    margin: 0 0 0 8px;
    cursor: pointer;
`;

export const QuintileInformation = styled('div')`
    display: flex;
    width: 100%;
    position: relative;
    flex-wrap: wrap;
    gap: 4px 8px;
    margin-bottom: 12px;
`;

export const ProgramRow = styled('div')`
    display: flex;
    flex-wrap: wrap;
    max-width: inherit;
    position: relative;
    font-weight: 400;

    .program-spacing {
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
    }

    .program-spacing-hpd {
        display: flex;
        flex-wrap: wrap;
        gap: 4px 0px;
    }

    .program {
        display: flex;
        flex-wrap: nowrap;
        font-size: 10px;
        line-height: 12px;
        height: 12px;
        white-space: pre;

        a {
            font-family: Proxima N W15 Smbd, Arial, Helvetica Neue, Helvetica, sans-serif;
            color: ${blueLink};
            &:hover {
                opacity: 0.5;
            }
        }
        .ec3Rect {
            margin: 1.5px 4px 0 0;
        }

        &.has-hpd-results {
            margin-right: 4px;
        }

        &.low-emitting {
            white-space: pre;
        }
    }
    .results {
        flex-wrap: nowrap;
        font-size: 10px;
        display: flex;
        font-family: 'Proxima Nova';
        line-height: 12px;
        height: 12px;

        &.hpd {
            flex-wrap: nowrap;
            white-space: pre;
        }

        &.lpc {
            margin-left: 4px;
    }
`;

export const TipContainer = styled('span')`
    text-transform: initial;
    white-space: normal;
    background: url(src/assets/images/icon-tooltip_darker.svg) no-repeat 0 0;
    background-size: 10px 10px;
    float: right;
    margin: 0 0 0 0;
    width: 10px;
    height: 10px;
    cursor: pointer;
    .ant-image {
        display: flex;
    }
    img {
        cursor: pointer;
    }
    .program-tip {
        display: none;
        &:hover {
            display: block;
        }
    }
    .tooltip-ec3 {
        display: none;
        &:hover {
            display: block;
        }
    }
    .tooltip-epdpt {
        display: none;
        &:hover {
            display: block;
        }
    }
    &:hover {
        .program-tip,
        .tooltip-ec3 {
            z-index: 1;
            display: block;
            margin-left: 9px;
            margin-top: -20px;
            position: absolute;
            border-radius: 3px;
            background: #ffffb8;
            color: ${black};
            &.products-tab {
                margin-left: 5px;
            }
        }

        .tooltip-ec3 {
            border: 1px solid grey;
            box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.5);
        }

        .tooltip-epdpt {
            z-index: 1;
            display: block;
            margin-left: 9px;
            margin-top: -20px;
            position: absolute;
            border-radius: 3px;
            background: #ffffb8;
            color: ${black};
            &.products-tab {
                margin-left: 5px;
            }
        }

        .tooltip-epdpt {
            border: 1px solid grey;
            box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.5);
        }

        .shadow {
            border: 1px solid grey;
            box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.5);
        }
    }
    &.ec3 {
        display: inline;
        margin-top: 0px;
        margin-left: 3px;
    }
`;

export const PercentageText = styled('div')`
    display: inline;
    margin-top: 0;
`;

export const ColorCircle = styled('span')`
    border-radius: 5px;
    font-weight: 400;
    background-color: ${(props: { color: string }) => props.color};
    display: inline-block;
    height: 10px;
    margin-right: 3px;
    padding: 0;
    width: 10px;
`;

export const ResultTextAfterCircle = styled('div')`
   
`;

export const TipContainerImpactAreas = styled('span')`
    text-transform: initial;
    white-space: normal;
    background: url(src/assets/images/mfr-question.svg) no-repeat 0 0;
    background-size: 10px 10px;
    float: inherit;
    margin: 0 0 0 20px;
    width: 14px;
    height: 14px;
    cursor: pointer;
    .ant-image {
        display: flex;
    }
    img {
        cursor: pointer;
    }
    .program-tip {
        display: none;
        &:hover {
            display: block;
        }
    }
    .tooltip-ec3 {
        display: none;
        &:hover {
            display: block;
        }
    }
    .tooltip-epdpt {
        display: none;
        &:hover {
            display: block;
        }
    }
    &:hover {
        .program-tip,
        .tooltip-ec3 {
            z-index: 1;
            display: block;
            margin-left: 9px;
            margin-top: -20px;
            position: absolute;
            border-radius: 3px;
            background: #ffffb8;
            color: ${black};
            &.products-tab {
                margin-left: 5px;
            }
        }

        .tooltip-ec3 {
            border: 1px solid grey;
            box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.5);
        }

        .tooltip-epdpt {
            z-index: 1;
            display: block;
            margin-left: 9px;
            margin-top: -20px;
            position: absolute;
            border-radius: 3px;
            background: #ffffb8;
            color: ${black};
            &.products-tab {
                margin-left: 5px;
            }
        }

        .tooltip-epdpt {
            border: 1px solid grey;
            box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.5);
        }

        .shadow {
            border: 1px solid grey;
            box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.5);
        }
    }
    &.ec3 {
        display: inline;
        flex-wrap: wrap;
        margin-top: 0px;
        margin-left: 3px;
    }
`;

export const DotsAction = styled('div')`
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: ${grayDark05};
    box-shadow: 0px 8px 0px ${grayDark05}, 0px 16px 0px ${grayDark05};
    position: absolute;
    top: 13px;
`;

export const OpenMenuButton = styled('button')`
    border: none;
    position: relative;
    background-color: transparent;
    cursor: pointer;
    padding: 20px;

    div {
        top: 33%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    &:hover {
        background-color: ${blue04};
    }
`;
export const ProductActionMenuItem = styled('span')`
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: ${grayDark03};
    white-space: nowrap;
`;

export const EPDBlock = styled('div')`
    width: 100%;
    display: flex;
    gap: 8px;
`;

export const MaterialProgramBlock = styled('div')`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 4px 8px;
`;

export const SectionDivider = styled('div')`
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid ${grayLight01};
`;

export const RowFlex = styled('div')`
    display: flex;
    flex-direction: row;
    flex: 1 1 auto;
    align-items: stretch;
`;

export const NoTagsText = styled(Text)`
    color: ${grayDark05};
    font-family: "Proxima Nova";
    font-size: 9px;
    font-style: normal;
    font-weight: 400;
    line-height: 11px;
    text-transform: uppercase;
`;